//#region imports

// react
import React, { useEffect, useRef, useState } from 'react';

// react-qr-code
import { QRCode } from 'react-qrcode-logo';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { getAirportRetailers, selectRetailers } from '_redux/slices/marketplace/retailer';

// react-bootstrap
import { Button, Container, Col, Form, Row } from 'react-bootstrap';

import logo from '../../../assets/images/prm-logo/blue-icon.png';
import { useSelect } from 'react-select-search';
//#endregion imports


const GenerateQRCode = () => {

    //#region redux and hooks
    const dispatch = useDispatch()
    const qrRef = useRef(null);

    const retailersIata = useSelector(selectRetailers)
    //#endregion

    //#region state
    const [customLink, setCustomLink] = useState(false);
    const [link, setLink] = useState("https://prmassist.com/");

    const [qrCodeUrl, setQrCodeUrl] = useState(null);
    const [retailerId, setRetailerId] = useState(null)
    const [tableNumber, setTableNumber] = useState(null)

    const retailers = retailersIata.map(retailer => ({
        id: retailer.id,
        title: retailer.retailerName
    }));

    //#endregion state

    //#region use effects
    // getting retailer list by iata, not enabled
    useEffect(() => {
        dispatch(getAirportRetailers("DUB"))
    }, [])

    //#endregion use effects

    //#region handlers

    // generate qr code url based on retailer and table number
    const handleGenerateQRCode = () => {
        let url = window.location.origin + '/retailer-products/';                // dynamic url based on current origin 
        const generatedURL = `${url}${retailerId}?tableNumber=${tableNumber}`
        setQrCodeUrl(generatedURL);
    }

    const handleGenerateCustomQRCode = () => {
        // check for link
        if(link.trim() === "") {
            alert("Please enter a valid URL");
            return;
        }
        else {
            console.log("Generating QR Code for custom link:", link);
            // generate qr code url based on custom link
            const generatedURL = `${link}`;
            setQrCodeUrl(generatedURL);
            //setCustomLink(false); // reset custom link state
            //setLink(""); // reset link input
        }
    }

    // download qr-code
    const handleDownloadQrCode = () => {
        const svg = qrRef.current?.querySelector("svg");
        const canvas = qrRef.current?.querySelector("canvas");
    
        if (canvas) {
            // For canvas-based QR code (react-qrcode-logo default)
            const pngFile = canvas.toDataURL("image/png");
            const downloadLink = document.createElement("a");
            downloadLink.href = pngFile;
            downloadLink.download = `${retailerId || "custom"}-${tableNumber || "qr"}.png`;
            downloadLink.click();
        } else if (svg) {
            // For svg-based QR codes
            const svgData = new XMLSerializer().serializeToString(svg);
            const img = new Image();
            const canvasEl = document.createElement("canvas");
            const ctx = canvasEl.getContext("2d");
    
            img.onload = function () {
                canvasEl.width = img.width;
                canvasEl.height = img.height;
                ctx.drawImage(img, 0, 0);
                const pngFile = canvasEl.toDataURL("image/png");
    
                const downloadLink = document.createElement("a");
                downloadLink.href = pngFile;
                downloadLink.download = `${retailerId || "custom"}-${tableNumber || "qr"}.png`;
                downloadLink.click();
            };
    
            img.src = "data:image/svg+xml;base64," + btoa(svgData);
        } else {
            console.error("QR code not found.");
        }
    };    

    // handle follow link click
    const handeClickLink = () => {
        if (qrCodeUrl) {
            window.open(qrCodeUrl, '_blank');
        }
    }
    //#endregion handlers

    return (
        <Container className="py-5">
            { customLink ?
                <Row>

                    <Col xs={12} md={10} lg={8}>
                        <div className="mb-4 text-center">
                            <h3 className="fw-bold">Generate Custom QR Code</h3>
                            <p className="text-muted">Paste the url link into the form input below</p>
                        </div>

                        <Form>
                            <Row className="g-4 align-items-end">
                                {/* link input */}
                                <Col xs={12} md={6}>
                                    <Form.Label className="fw-semibold">URL</Form.Label>
                                    <Form.Control
                                        onChange={e => {
                                            setLink(e.target.value);
                                        }}
                                        value={link}
                                        name="link"
                                        type="string"
                                        placeholder="Enter the url link"
                                    />
                                </Col>
                                
                                <div style={{ padding:12}}>
                                <Button
                                    //disabled={!retailerId || !tableNumber}
                                    variant="primary"
                                    onClick={handleGenerateCustomQRCode}
                                    style={{ minWidth: 180, }}
                                >
                                    Generate QR Code
                                </Button>
                                </div>
                            </Row>
                        </Form>
                    </Col>

                </Row>
            :
            <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8}>
                    <div className="mb-4 text-center">
                        <h3 className="fw-bold">Generate QR Code</h3>
                        <p className="text-muted">Select a retailer and enter a table number to generate a QR code.</p>
                    </div>

                    <Form>
                        <Row className="g-4 align-items-end">

                            {/* Retailer Dropdown */}
                            <Col xs={12} md={6}>
                                <Form.Label className="fw-semibold">Retailer</Form.Label>
                                <Form.Select
                                    onChange={(e) => setRetailerId(e.target.value)}
                                    name="retailerId"
                                    value={retailerId}
                                >
                                    <option value="DEFAULT">Select Retailer</option>
                                    {retailers.map((retailer) => (
                                        <option key={retailer.id} value={retailer.id}>
                                            {retailer.title}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Col>

                            {/* Table Number Input */}
                            <Col xs={12} md={6}>
                                <Form.Label className="fw-semibold">Table Number</Form.Label>
                                <Form.Control
                                    onChange={e => {
                                        const v = Number(e.target.value);
                                        if (!Number.isNaN(v) && v > 0) {
                                            setTableNumber(v);
                                        }
                                    }}
                                    value={tableNumber}
                                    name="tableNumber"
                                    type="number"
                                    placeholder="Enter the table number"
                                />
                            </Col>
                        </Row>

                        {/* Generate Button */}
                        <div className="text-center mt-4 display-flex flex-column gap-3">
                            <Button
                                disabled={!retailerId || !tableNumber}
                                variant="primary"
                                onClick={handleGenerateQRCode}
                                style={{ minWidth: 200 }}
                            >
                                Generate QR Code
                            </Button>

                            <Button
                                variant="secondary"
                                onClick={() => { setCustomLink(true) }}
                                style={{ minWidth: 200 }}
                            >
                                Custom Link
                            </Button>
                        </div>
                    </Form>
                </Col>
            </Row>
        }
            {/* Show QR Code after generating */}
            <Row>
                {qrCodeUrl && (
                    <div className="text-center mt-4">
                        <div ref={qrRef} className='mt-3'>
                            <QRCode 
                                value={qrCodeUrl} 
                                logoWidth={40} 
                                removeQrCodeBehindLogo={false}    
                                logoImage={logo}
                            />

                        </div>
                        <p className="mt-2 text-muted" style={{ fontSize: "0.9rem" }}>
                            Scan this code to visit the table link, or you can save QR code Image,
                            NOTE: Make sure to test the QR Code before using it in production.
                        </p>
                        <button onClick={handleDownloadQrCode} className="mt-2 btn btn-success">
                            Download QR Code
                        </button>
                        { !customLink && <button onClick={handeClickLink} className="mt-2 btn">
                            Follow Link
                        </button>
            }
                    </div>
                )}
            </Row>
        </Container>
    );

};

export default GenerateQRCode;
